<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Update User</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-multiline">
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Email Address"
                            rules="required|email"
                          >
                            <b-field
                              label="Email Address"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.email" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="First Name"
                            rules="required"
                          >
                            <b-field
                              label="First Name"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.firstName" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Last Name"
                            rules="required"
                          >
                            <b-field
                              label="Last Name"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.lastName" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Company"
                            rules="required"
                          >
                            <b-field
                              label="Company"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.company" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Job Title"
                            rules="required"
                          >
                            <b-field
                              label="Job Title"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.jobTitle" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Phone"
                            rules="required"
                          >
                            <b-field
                              label="Phone"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.phone" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-12-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="User Roles"
                            rules="required"
                          >
                            <b-field
                              label="User Roles"
                              class="is-block"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-checkbox
                                v-model="item.role"
                                native-value="admin"
                              >
                                Admin
                              </b-checkbox>
                              <b-checkbox
                                v-model="item.role"
                                native-value="scheduler"
                              >
                                Scheduler
                              </b-checkbox>
                              <b-checkbox
                                v-model="item.role"
                                native-value="traffic"
                              >
                                Traffic
                              </b-checkbox>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name: 'ManageUsers'
                          }"
                        >
                          Back to List</b-button
                        >
                        <b-button
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name: 'AdminChangePassword',
                            params: { id: item.id }
                          }"
                        >
                          Update Password</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CardComponent from '@/components/CardComponent'
import UserApi from '@/api/user'
export default {
  name: 'UpdateProfile',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Update User'
  },
  data() {
    return {
      initialized: false,
      loading: false,
      item: {
        email: '',
        firstName: '',
        lastName: '',
        company: '',
        jobTitle: '',
        phone: '',
        role: []
      }
    }
  },
  mounted() {
    UserApi.getById(this.$route.params.id).then(user => {
      this.item = {
        id: user.id,
        email: user.email,
        firstName: user.first_name,
        lastName: user.last_name,
        company: user.company,
        jobTitle: user.job_title,
        phone: user.phone,
        role: user.role.split(',')
      }
      this.initialized = true
    })
  },
  methods: {
    ...mapActions(['getUser', 'refreshToken']),
    async submit() {
      this.loading = true
      try {
        await UserApi.adminUpdate({
          id: this.item.id,
          email: this.item.email,
          firstName: this.item.firstName,
          lastName: this.item.lastName,
          company: this.item.company,
          jobTitle: this.item.jobTitle,
          phone: this.item.phone,
          role: this.item.role
        })
        this.$buefy.toast.open({
          message: 'The user has been updated successfully',
          position: 'is-top',
          type: 'is-success'
        })
        this.loading = false
      } catch (err) {
        console.log(err)
        this.$buefy.toast.open({
          message: 'Error updating user',
          position: 'is-top',
          type: 'is-danger'
        })
        this.loading = false
      }
    }
  }
}
</script>
